export default __webpack_public_path__ + "static/media/1.13c46517.png";